import styled from '@emotion/styled';

import { COLORS } from '../../constants';

export const StyledSaveProformaType = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 50%;
  min-height: 276px;

  margin-top: 21px;

  background-color: ${COLORS.gray95};
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2);
`;

export const StyledSaveProformaTypesWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledSaveImageWrapper = styled.div`
  width: 148px;

  margin-bottom: 34px;
`;

export const StyledSavePopupImage = styled.img`
  width: 100%;
`;
